import { Input, Textarea, Select } from 'peach/components'

import CaseTypeIdSelect from '../case/CaseTypeSelect'

const CreateCaseForm = () => (
  <>
    <CaseTypeIdSelect formKey='typeId' required />

    <Input formKey='externalId' />

    <Select boolean formKey='autoCreated' />

    <Select
      formKey='status'
      nullable
      options={['initiated', 'processing', 'completed', 'canceled', 'reopened']}
    />

    <Textarea.Json formKey='metaData' />
  </>
)

export default CreateCaseForm
